"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.validation.nameRequired': 'El nombre del tutorial es obligatorio',
    'tutorial.validation.sectionsRequired': 'Se requiere al menos una sección',
    'tutorial.validation.sectionTitleRequired': 'El título de la sección {index} es obligatorio',
    'tutorial.validation.stepsRequired': 'Se requiere al menos un paso',
    'tutorial.validation.stepTitleRequired': 'El título del paso {index} es obligatorio',
    'tutorial.validation.stepSectionsRequired': 'El paso {index} debe tener al menos una sección',
};
